import React, { Component } from "react";
import Loadable from "react-loadable";
import { Loader } from "ui/loader";
import AuthStore from "../data/auth";

export type IRoute = {
  path: String,
  /** Top menu label */
  label?: String,
  init?: (params: Object) => Promise,
  noAuth: boolean,
  hideToolbar: boolean;
  /** HIde this entry from top menu */
  hideMenu: boolean,
  /** Only show if user is admin */
  admin?: boolean,
  /** If dispabled then element will be hidden from menu */
  disabled?: (params: Object) => boolean,
  /** Disable the top menu */
  disableMenu: boolean,
  /** Hide the workspace select in top menu */
  hideWorkspaceSelect: boolean,
  /** Curstom compoentn in the top menu */
  titleComponent?: Component,
  routes?: IRoute[],
  /** DO NOT SET THIS, used when constructing flat menu */
  parent: IRoute
};

export function flatRouteList(...routes: IRoute[]): IRoute[] {
  const SUB_ROUTES: IRoute[] = [];
  const ROOT_PARENT = { routes };

  let res: IRoute[] = [];
  for (let route of routes) {
    route.parent = ROOT_PARENT;
    const subroutes = route.routes;
    if (subroutes) {
      let i = subroutes.length;
      while (i--) {
        const subroute = subroutes[i];
        subroute.parent = route;
        subroute.path = route.path + subroute.path;
        res.push(subroute);
        SUB_ROUTES.push(subroute);
      }
    }
  }
  res.push.apply(res, routes.slice().reverse());

  return res;
}

export function AsyncRoute(importFunc) {
  return Loadable({
    loader: importFunc,
    loading: props => {
      if (props.error) {
        console.error("Failed to load route", props.error);
        return <h2 className="text-error">Failed to load route</h2>;
      }
      return <Loader />;
    }
  });
}

export const MenuHeader = header => () => <h1>{header}</h1>;

/**
 * Concatinates path arguments with /
 * Removes undefined path parameters and parameters = userID
 * @param {String} path
 */
export const buildPath = (...path: String[]): String =>
  "/" + path.filter(p => !!p && p !== AuthStore.getId()).join("/");

/**
 * Fills in react router path with params, removes unused optinal parameters from path
 * @param {String} path - react router firnated path, exanoke "path/:key/:optinalKey?"
 * @param {*} params - params to fill in path with
 */
export const pathWithParams = (
  path: String,
  params: { [String]: String }
): String => {
  for (let key in params) {
    const param = params[key];
    if (param) path = path.replace(new RegExp(":" + key + "\\??"), param);
  }

  return path
    .replace("/" + AuthStore.getId(), "")
    .replace(/\/:.+?(?=(\/|$))/, "");
};

export function getQueryKey(key: string): string {
  const query = location.search.replace("?", "").split("&");
  const reg = new RegExp(`^${key}=`, "i");
  for (let q of query) {
    if (reg.test(q)) {
      return q.split("=")[1];
    }
  }
}

window.getQueryKey = getQueryKey;
